/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CertificateStatus {
  ACTIVE = 'active',
  ACTIVE_NO_INSURANCE = 'active_no_insurance',
  EXPIRED = 'expired',
  VOLUNTARILY_SURRENDERED = 'voluntarily_surrendered',
  REVOKED = 'revoked',
  REVOKED_UNSATISFACTORY = 'revoked_unsatisfactory',
  SUSPENDED = 'suspended',
  RED_BANNER = 'red_banner',
}
